module.exports = __webpack_public_path__ + "static/media/IMG_4254.607987d4.PNG";